import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { SwiperModule } from 'ngx-swiper-wrapper';
import { SwiperModule } from 'swiper/angular';
// import { PricesComponent } from './components/prices/prices.component';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { SectionFeaturesModule } from '@studiobuki/web-core/lib/section-features';
import { SectionFaqModule } from '@studiobuki/web-core/lib/section-faq';
import { SectionMessageDateModule } from '@studiobuki/web-core/lib/section-message-date';
import { BookFormModule } from '@studiobuki/web-core/lib/book-form';
import { PreviewModule } from '@studiobuki/web-core/lib/preview';
import { SectionStepsModule } from '@studiobuki/web-core/lib/section-steps';
import { SectionAboutBannerModule } from 'src/app/shared/section-about-banner/section-about-banner.module';
import { SectionFooterBannerModule } from 'src/app/shared/section-footer-banner/section-footer-banner.module';
import { YotpoV3Module } from '@studiobuki/web-core/lib/yotpo-v3';
import { RouterLink } from '@angular/router';
import { SectionReviewsModule } from '@studiobuki/web-core/lib/section-reviews';
import { BannerComponent } from './components/banner/banner.component';
import { SectionDetailsComponent } from './section-details.component';
import { SectionFooterBannersModule } from '../../../../shared/section-footer-banners/section-footer-banners.module';

@NgModule({
  declarations: [
    SectionDetailsComponent,
    // PricesComponent,
    BannerComponent,
  ],
  imports: [
    CommonModule,
    SwiperModule,
    BookFormModule,
    ButtonModule,
    SectionFeaturesModule,
    // SectionSeeOtherModule,
    YotpoV3Module,
    SectionStepsModule,
    SectionFaqModule,
    SectionMessageDateModule,
    // SectionBannerMermaidModule,
    PreviewModule,
    SectionAboutBannerModule,
    SectionFooterBannerModule,
    RouterLink,
    SectionReviewsModule,
    SectionFooterBannersModule,
  ],
  exports: [SectionDetailsComponent],
})
export class SectionDetailsModule {}
